import { Field, Fields } from "../forms/interfaces/Field.interface";

export function isField(field: Field | Fields): field is Field {
  return "path" in field;
}
